import $ from 'jquery'
import CollectionTeaserManager from 'collection-teaser/js/collection-teaser'

$(function() {
   if( $('.collection-teaser').length > 0 ){
      const collectionTeasers = new CollectionTeaserManager();
   }
});